const PLAY_REQUEST_KEY_PREFIX = "lottery:play-request:";
const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const createPlayRequestId = () => {
  if (typeof window.crypto?.randomUUID === "function") {
    return window.crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof window.crypto?.getRandomValues === "function") {
    window.crypto.getRandomValues(bytes);
  } else {
    bytes.forEach((_, index) => {
      bytes[index] = Math.floor(Math.random() * 256);
    });
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));

  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
};

const storageKey = (campaignId: string) =>
  `${PLAY_REQUEST_KEY_PREFIX}${campaignId}`;

export const getOrCreatePlayRequestId = (campaignId: string) => {
  try {
    const key = storageKey(campaignId);
    const storedRequestId = window.sessionStorage.getItem(key);
    if (storedRequestId && UUID_PATTERN.test(storedRequestId)) {
      return storedRequestId;
    }

    const requestId = createPlayRequestId();
    window.sessionStorage.setItem(key, requestId);
    return requestId;
  } catch {
    return createPlayRequestId();
  }
};

export const clearPlayRequestId = (
  campaignId: string,
  completedRequestId: string
) => {
  try {
    const key = storageKey(campaignId);
    if (window.sessionStorage.getItem(key) === completedRequestId) {
      window.sessionStorage.removeItem(key);
    }
  } catch {
    // Storage access is optional; the in-memory request ID still protects retries.
  }
};
